import { News } from '../../../../types/news';

export const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;
export interface GroupedNewsByDay {
  day: typeof DAY_LABELS[number];
  news: News[];
}
